import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	header: {
		height: "150px",
		boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.08)",
		backgroundColor: "#fafafa",
		padding: 17,
	},
	title: {
		color: "rgba(71, 71, 71, 0.82)",
		fontSize: 20,
		fontWeight: "bold",
		paddingTop: 15,
	},
	subTitle: {
		fontSize: 12,
		color: "rgba(71, 71, 71, 0.5)",
	},
	icon: {
		cursor: "pointer",
		color: "#474747",
	},
	image: {
		height: "40px",
		width: "40px",
		borderRadius: "20px",
		border: "1px solid white",
	},
	headerCard: {
		padding: "20px 20px 0 20px",
		display: "flex",
		alignContent: "center",
		justifyContent: "flex-start",
	},
	professionalTitle: {
		color: "#474747",
		width: "100%",
		fontSize: 14,
		fontWeight: "bold",
		alignSelf: "center",
	},
	bookingDiv: {
		display: "flex",
		width: "100%",
		justifyContent: "flex-end",
	},
	bookingTitle: {
		alignSelf: "center",
		fontSize: 14,
		color: "rgba(71, 71, 71, 0.5)",
	},
	servicesDiv: {
		padding: "5px 20px 0 20px",
		display: "flex",
		alignContent: "center",
		justifyContent: "flex-start",
	},
	serviceTitle: {
		color: "#474747",
		fontSize: 12,
		marginRight: "8px",
	},
	duration: {
		fontSize: 12,
		color: "rgba(71, 71, 71, 0.5)",
	},
	price: {
		fontSize: 14,
		color: "#3689ea",
		fontWeight: "bold",
	},
	priceDetailBlue: {
		color: "#3689ea",
		fontSize: 12,
		fontWeight: " bold",
	},
	priceDetail: {
		color: "rgba(71, 71, 71, 0.5)",
		fontSize: 12,
		fontWeight: " bold",
	},
	paymentDetail: {
		color: "#393762",
		fontSize: 12,
		fontWeight: "bold",
	},
	observationIcon: {
		marginLeft: "0px",
		marginRight: "10px",
		color: "#474747",
	},
	question: {
		wordWrap: "break-word",
		width: "100%",
		height:"auto",
		color: "#474747",
		fontSize: "19px",
	},
	questionLink: {
		maxWidth: "100%",
		color: "#7A4E2D",
		fontSize: 'clamp(18px, 1vw, 14px)',
		textTransform:"none",
		padding:"0",
		margin:"0",
		cursor:"pointer"
	},
	characterCount: {
		color: "#474747",
		fontSize: "clamp(14px, 1vw, 18px)",
	},
	observation: {
		marginTop: "10px",
		width: "100%",
	},
	root: {
		backgroundColor: "#440067",
		color: "#ffffff",
		height: 44,
		width: 335,
		fontSize: 12,
		fontWeight: "normal",
		textTransform: "none",
		borderRadius: 20,
		"&:hover": {
			backgroundColor: "#106ba3",
		},
	},
	titlePage: {
		fontSize: 'clamp(32px, 1vw, 36px)',
		color: "#fff", 
		textAlign: "center", 
		lineHeight: "1.2",
		fontWeight: 500,
		padding: "0 20px",
	},
	text: {
		fontSize: 'clamp(16px, 1vw, 20px)',
		color: "#222", 
		lineHeight: "1.2",
		fontWeight: 400,
	},
	buttonChoosePayment: {
		backgroundColor: "transparent",
		border: "1px solid #222",
		color: "#222",
		height: 44,
		width: 335,
		fontSize: 'clamp(14px, 1vw, 18px)',
		fontWeight: 600,
		textTransform: "none",
		borderRadius: 20,
		"&:hover": {
			backgroundColor: "#672E37",
			color: "#fff",
			border: "1px solid #672E37",
		},
	},
	buttonChooseLogin: {
		backgroundColor: "transparent",
		color: "#222",
		height: 44,
		width: 335,
		fontSize: 'clamp(14px, 1vw, 18px)',
		fontWeight: 600,
		textTransform: "none",
		borderRadius: 20,
	},
	// Policy
	policyWrapper: {
		color: "#222",
		textAlign: "center",
		justifyContent: "center",
		fontSize: 'clamp(14px, 1vw, 18px)',
		fontWeight: "bold",
		padding: "0 16px",
	},

	headerAvatar: {
		width: 48,
		height: 48,
		backgroundColor: "#222",
	},

	professionalName: {
		fontSize: 16,
		color: "#222",
		fontWeight: 600,
	},

	serviceDate: {
		fontSize: "16px",
		color: "#222",
	},

	serviceDuration: {
		fontSize: "16px",
		color: "#222",
	},

	confirmPhoneTitle: {
		fontSize: "clamp(24px, 1vw, 28px)",
		textAlign: "center",
		color: "#222",
		marginTop: 10,
		width: "90%",
		fontWeight: "bold",
	},

	confirmPhoneSubtitle: {
		fontSize: "clamp(16px, 1vw, 18px)",
		textAlign: "center",
		color: "#666666",
		marginTop: 10,
		width: "85%",
		marginBottom: 20,
	},

	"@keyframes slideUpFooter": {
		from: {
			transform: "translateY(100%)",
			opacity: 0,
		},
		to: {
			transform: "translateY(0)",
			opacity: 1,
		},
	},

	footerAnimated: {
		animation: "$slideUpFooter 0.6s ease-out",
		boxShadow: '0 -4px 6px rgba(0, 0, 0, 0.1)',
		borderRadius: "20px 20px 0 0",
	},

	// Modal de validação de sucesso
	validationModalBackdrop: {
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		zIndex: 9998,
		animation: "$fadeIn 0.3s ease-out",
	},

	"@keyframes fadeIn": {
		from: {
			opacity: 0,
		},
		to: {
			opacity: 1,
		},
	},

	"@keyframes slideUpModal": {
		from: {
			transform: "translateY(100%)",
			opacity: 0,
		},
		to: {
			transform: "translateY(0)",
			opacity: 1,
		},
	},

	validationModalContainer: {
		position: "fixed",
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 9999,
		animation: "$slideUpModal 0.6s ease-out",
	},

	validationModalContent: {
		backgroundColor: "#fff",
		borderRadius: "30px 30px 0 0",
		padding: "40px 20px 30px",
		maxWidth: "500px",
		width: "100%",
		margin: "0 auto",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.15)",
	},

	validationModalIconContainer: {
		marginBottom: "24px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},

	validationModalIcon: {
		fontSize: "80px",
		color: "#4CAF50",
	},

	validationModalTitle: {
		fontSize: "clamp(24px, 5vw, 28px)",
		fontWeight: 700,
		color: "#222",
		textAlign: "center",
		marginTop: "24px",
		marginBottom: "16px",
		lineHeight: 1.3,
	},

	validationModalSubtitle: {
		fontSize: "clamp(16px, 4vw, 18px)",
		fontWeight: 400,
		color: "#666",
		textAlign: "center",
		marginBottom: "32px",
		lineHeight: 1.4,
	},

	validationModalButton: {
		backgroundColor: "#672E37",
		color: "#fff",
		height: "56px",
		width: "100%",
		maxWidth: "335px",
		fontSize: "clamp(16px, 4vw, 18px)",
		fontWeight: 700,
		textTransform: "uppercase",
		borderRadius: "28px",
		padding: "0 40px",
		marginTop: "8px",
		"&:hover": {
			backgroundColor: "#4a2027",
		},
	},
}));
